import { create } from 'zustand';
import { User } from '@/types';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  login: (user: User, token: string) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
  initializeAuth: () => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  token: null,
  isAuthenticated: false,

  initializeAuth: () => {
    console.log('🔍 initializeAuth called');
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    
    console.log('🔍 Token in localStorage:', token ? token.substring(0, 20) + '...' : 'NULL');
    console.log('🔍 User in localStorage:', userStr ? 'exists' : 'NULL');
    
    if (token && userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user) {
          console.log('✅ Setting authenticated state with user:', user.email);
          set({ user, token, isAuthenticated: true });
        } else {
          console.log('❌ User data is null after parsing - staying unauthenticated');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      } catch (error) {
        console.error('❌ Error parsing stored user data:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    } else {
      console.log('❌ No token or user found - staying unauthenticated');
    }
  },

  login: (user: User, token: string) => {
    console.log('🔑 Login - storing token:', token.substring(0, 20) + '...');
    console.log('🔑 Login - storing user:', user);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ user, token, isAuthenticated: true });
    // Force a sync by triggering a storage event
    window.dispatchEvent(new StorageEvent('storage', { key: 'token', newValue: token }));
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    set({ user: null, token: null, isAuthenticated: false });
  },

  updateUser: (userData: Partial<User>) => {
    const currentUser = get().user;
    if (currentUser) {
      const updatedUser = { ...currentUser, ...userData };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      set({ user: updatedUser });
    }
  },
}));